Ext.define('SA.view.NumberField', {
    alias: 'widget.sa-numberfield',
    extend: 'Ext.form.field.Number',

    allowExponential: false,
    enforceMaxLength: true,
    hideTrigger: true,
    maxLength: 15,

    beforeRender() {
        this.addCls('sa-numberfield');
        this.callParent();
    }
});